import { invalidateQuery } from './createApiQueryOptions';
import { setMethodMutableOverride } from '../../apis-infra/utils/internal';
const isDeepStrictEqual = (val1, val2) => {
  const isArrays = Array.isArray(val1) && Array.isArray(val2);
  const isObjects = typeof val1 === 'object' && typeof val2 === 'object';
  if (isArrays) {
    return val1.length === val2.length && val1.every((v, i) => isDeepStrictEqual(v, val2[i]));
  }
  if (isObjects) {
    const val2Entries = Object.entries(val2);
    const val1Entries = Object.entries(val1);
    return val1Entries.length === val2Entries.length && val1Entries.every((_ref, i) => {
      let [k, v] = _ref;
      return k === val2Entries[i][0] && isDeepStrictEqual(v, val2Entries[i][1]);
    });
  }
  return val1 === val2;
};

/** *
 * this invalidates the method query as will cause refetch, handle with care!
 */
export function setMethodOverride(methodConfig, override, refetch) {
  const prevValue = methodConfig._mutableOverride;
  setMethodMutableOverride(methodConfig, override);
  if (refetch && !isDeepStrictEqual(prevValue, override)) {
    invalidateQuery(methodConfig);
  }
  return prevValue;
}
//# sourceMappingURL=internal.js.map